__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "next";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/cache", "11.14.0", () => (() => (__webpack_require__(89757))), 1);
			register("@emotion/is-prop-valid", "1.4.0", () => (() => (__webpack_require__(71068))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(78265))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(92110))), 1);
			register("@mui/material", "7.3.11", () => (() => (__webpack_require__(98287))), 1);
			register("@mui/private-theming", "7.3.11", () => (() => (__webpack_require__(80138))), 1);
			register("@mui/styled-engine", "7.3.10", () => (() => (__webpack_require__(73326))), 1);
			register("@mui/system", "7.3.11", () => (() => (__webpack_require__(92071))), 1);
			register("@mui/utils", "7.3.11", () => (() => (__webpack_require__(15235))), 1);
			register("next/dynamic", "15.5.18", () => (__webpack_require__.e(152).then(() => (() => (__webpack_require__(5152))))));
			register("next/head", "15.5.18", () => (__webpack_require__.e(527).then(() => (() => (__webpack_require__(9008))))));
			register("next/image", "15.5.18", () => (Promise.all([__webpack_require__.e(675), __webpack_require__.e(493)]).then(() => (() => (__webpack_require__(25675))))));
			register("next/link", "15.5.18", () => (Promise.all([__webpack_require__.e(871), __webpack_require__.e(151)]).then(() => (() => (__webpack_require__(41664))))));
			register("next/router", "15.5.18", () => (Promise.all([__webpack_require__.e(871), __webpack_require__.e(163), __webpack_require__.e(220)]).then(() => (() => (__webpack_require__(11163))))));
			register("next/script", "15.5.18", () => (__webpack_require__.e(298).then(() => (() => (__webpack_require__(4298))))));
			register("react-dom/client", "19.2.4", () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(20745))))));
			register("react-dom", "19.2.4", () => (() => (__webpack_require__(73935))), 1);
			register("react/jsx-runtime", "19.2.4", () => (__webpack_require__.e(774).then(() => (() => (__webpack_require__(85893))))));
			register("react", "19.2.4", () => (() => (__webpack_require__(67294))), 1);
			register("styled-jsx/style", "5.1.6", () => (__webpack_require__.e(352).then(() => (() => (__webpack_require__(97352))))));
			register("styled-jsx", "5.1.6", () => (__webpack_require__.e(103).then(() => (() => (__webpack_require__(52103))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};